<script lang="ts" setup>
import type { ToMetaTagsType } from "vue-datocms";
import type { CatalogHeaderSectionRecord } from "~~/server/graphql/datocms/generated";
import { toHead } from "vue-datocms";

const { locale } = useI18n();
const { params } = useRoute();
const slug = params.slug || "home";

const { data } = await useFetch("/api/cms/page", {
  query: { slug: slug, locale: locale },
});

if (!data.value) {
  throw create404Error();
}

useDatoSlugsToI18n(data.value._allSlugLocales!);

useHead(() => {
  if (!data.value) {
    return {};
  }

  return toHead(data.value._seoMetaTags as ToMetaTagsType);
});

const catalogHeaderSection = computed(() => {
  return data.value?.sections.find(s => s.__typename === "CatalogHeaderSectionRecord") as CatalogHeaderSectionRecord;
});

const otherSections = computed(() => {
  return data.value?.sections.filter(s => s.__typename !== "CatalogHeaderSectionRecord");
});
</script>

<template>
  <div v-if="data" :class="{ 'mt-3xl': !catalogHeaderSection }">
    <Breadcrumbs v-if="!catalogHeaderSection" class="mb-sm" :page="data" />
    <SectionsCatalogHeader v-if="catalogHeaderSection" :page-title="data.title" :current-page-id="data.id" class="mb-lg" />
    <SectionsRenderer :sections="otherSections" :page-title="data.title" :current-page-id="data.id" />
  </div>
</template>

<style>

</style>
